import axios from 'axios'
import { apiEndpointBaseUrl } from '@/site-config'

const instance = axios.create({
  baseURL: apiEndpointBaseUrl,
  timeout: 15000,
  headers: {
    'Content-Type': 'application/json',
    'Accept-Language': 'nl-NL',
    'X-Country': 'nl'
  }
})

export default function (options) {
  return {
    getCategories () {
      return instance.get('/templates').then(resp => resp.data)
    },

    signup ({ siteName, email, password, phoneNumber, templateId }) {
      return instance.post('/account/signup', {
        siteName,
        email,
        password,
        phoneNumber,
        templateId
      })
    },

    createLead ({ name, email, phoneNumber, companyName, hasWebsite, wannaCopySite, currentWebsiteUrl, packageId }) {
      return instance.post('/leads', {
        name,
        email,
        phoneNumber,
        companyName,
        hasWebsite,
        wannaCopySite,
        currentWebsiteUrl,
        package: packageId
      })
    }
  }
}



// WEBPACK FOOTER //
// ./src/api/backend/index.js